import en from './en';

/**
 * All available message catalogs, keyed by locale code. Only English is shipped
 * for now; additional locales can be added here (and to LOCALES) as needed.
 */
export const messages: Record<string, Record<string, string>> = {
  en,
};

export interface LocaleOption {
  /** BCP-47-ish locale code used by react-intl and stored in state. */
  code: string;
  /** Native name (autonym) shown in the language switcher. */
  label: string;
}

/** Locales offered in the UI language switcher, in display order. */
export const LOCALES: LocaleOption[] = [
  { code: 'en', label: 'English' },
];

export const DEFAULT_LOCALE = 'en';

const LOCALE_STORAGE_KEY = 'aitras-locale';

/** Persists the chosen locale so it survives a page reload. */
export function persistLocale(code: string): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, code);
  } catch {
    // Ignore storage errors (private mode, disabled storage, etc.).
  }
}
